import { FaInstagram, FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import './contacto.css';

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="container">
        <h1 className="text-center mb-3">CONTÁCTANOS</h1>
        <p className="text-center text-secondary mb-4">
          ¿Tienes alguna pregunta o necesitas más información? Contáctanos y estaremos encantados de ayudarte.
        </p>
        <form>
          <div className="row mb-3">
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="NOMBRE" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="email" className="form-control" placeholder="CORREO ELECTRÓNICO" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="ASUNTO" />
            </div>
          </div>
          <div className="mb-3">
            <textarea className="form-control" rows="5" placeholder="MENSAJE"></textarea>
          </div>
          <div className="text-center">
            <button type="submit" className="btn btn-warning fw-bold">
              ENVIAR MENSAJE
            </button>
          </div>
        </form>
        {/* Bloque de Social Icons */}
        <div className="social-contact mt-2 text-center">
          <h2 className="mb-3">Síguenos en nuestras redes sociales</h2>
          <div className="social-icons-contact">
            <a href="https://www.instagram.com/workingunidos" target="_blank" rel="noopener noreferrer">
              <div className="social-icon">
                <FaInstagram />
              </div>
            </a>
            <a href="https://www.facebook.com/workingunidos" target="_blank" rel="noopener noreferrer">
              <div className="social-icon">
                <FaFacebookF />
              </div>
            </a>
            <a href="https://www.tiktok.com/@workingunidos" target="_blank" rel="noopener noreferrer">
              <div className="social-icon">
                <SiTiktok />
              </div>
            </a>
            <a href="https://x.com/workingunidos" target="_blank" rel="noopener noreferrer">
              <div className="social-icon">
                <FaTwitter />
              </div>
            </a>
            <a href="https://www.linkedin.com/company/workingunidos/" target="_blank" rel="noopener noreferrer">
              <div className="social-icon">
                <FaLinkedinIn />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;